import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'tourSearchModalForm',
    'clearButton',
    'searchRadio',
    'searchSelect',
    'searchInput',
    'detailedSearchArea',
    'detailedSearchHeader',
  ]

  connect() {
    // console.log('tour-searchable')
  }

  clearInputs() {
    const searchRadios = this.searchRadioTargets;
    searchRadios.forEach((radio) => {
      radio.checked = false;
    })

    const searchSelects = this.searchSelectTargets;
    searchSelects.forEach((select)=>{
      select.selectedIndex = -1;
    });

    const searchInputs = this.searchInputTargets;
    searchInputs.forEach((input)=>{
      input.value = '';
    });
  }

  toggleDetailedSearch(){
    const detailedSearchArea = this.detailedSearchAreaTarget;
    detailedSearchArea.classList.toggle('n-is-opened');

    if(detailedSearchArea.classList.contains('n-is-opened') === false){
      const searchSelects = this.searchSelectTargets;
      searchSelects.forEach((select)=>{
        select.selectedIndex = -1;
      });
    }
  }
}